export * as category from '@wix/auto_sdk_faq_category/meta';
export * as questionEntry from '@wix/auto_sdk_faq_question-entry/meta';
